/**
 * ContentLibraryView
 *
 * Full-page body for the cross-game Content Library — the home for reusable
 * content assets that are independent of any single game instance. Rendered as
 * an overlay from DashboardLayout (like GamesListView); the Back / title /
 * user-menu header lives in DashboardLayout.
 *
 * The shell is generic: it renders one tab per registered game-type module (see
 * ./registry). Trailblazers (its screenshot library) is the only module today.
 */

import { useState } from 'react';
import { type Tab } from '@swtorbit/shared-components';
import { Tabs } from '@swtorbit/ui/react';
import { CONTENT_LIBRARY_TABS } from './registry';

const TABS: Tab[] = CONTENT_LIBRARY_TABS.map((t) => ({ id: t.id, label: t.label, content: null }));

export function ContentLibraryView() {
  const [activeTab, setActiveTab] = useState<string>(CONTENT_LIBRARY_TABS[0]?.id ?? '');

  const renderTabContent = () => {
    const tab = CONTENT_LIBRARY_TABS.find((t) => t.id === activeTab);
    if (!tab) return null;
    const Body = tab.Component;
    return (
        <Body />
    );
  };

  return (
    <div className="d-flex flex-column flex-1">
      <Tabs center items={TABS.map((t) => ({ value: t.id, label: t.label }))} value={activeTab} onChange={setActiveTab}>{renderTabContent()}</Tabs>
    </div>
  );
}
